@if (isAuthReady()) {

  <evland-header></evland-header>

  <evland-toasts-area></evland-toasts-area>

  <router-outlet></router-outlet>

  <evland-footer></evland-footer>

} @else {

  <evland-section-loader label="Авторизуємося" i18n-label></evland-section-loader>

}
